import { render, staticRenderFns } from "./jf.vue?vue&type=template&id=3983a408&scoped=true&"
import script from "./jf.vue?vue&type=script&lang=js&"
export * from "./jf.vue?vue&type=script&lang=js&"
import style0 from "./jf.vue?vue&type=style&index=0&id=3983a408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983a408",
  null
  
)

export default component.exports